import { render, staticRenderFns } from "./BitQCinema.vue?vue&type=template&id=41f5ac80&scoped=true"
import script from "./BitQCinema.vue?vue&type=script&lang=js"
export * from "./BitQCinema.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f5ac80",
  null
  
)

export default component.exports